import '@fortawesome/fontawesome-free/js/all.js'
import '../scss/theme.scss'

const registerResponsiveHeaderCheck = () => {
    const header = document.querySelector('header')

    const left = header.querySelector('header .main > .left')
    const ul = header.querySelector('header .main > .center nav ul')
    const right = header.querySelector('header .main > .right')

    const firstItem = ul.querySelector('li:first-child')
    const lastItem = ul.querySelector('li:last-child')

    const minSpace = 15

    const check = () => {
        const spaceLeft = firstItem.getBoundingClientRect().left - left.getBoundingClientRect().right
        const spaceRight = right.getBoundingClientRect().left - lastItem.getBoundingClientRect().right

        if (spaceLeft < minSpace || spaceRight < minSpace) {
            if (!header.classList.contains('nav-main-hidden')) {
                header.classList.add('nav-main-hidden')
            }
        } else {
            if (header.classList.contains('nav-main-hidden')) {
                header.classList.remove('nav-main-hidden')
            }
        }
    }

    check()
    window.addEventListener('resize', check)
}

const addCoverBlockLinks = () => {
    document.querySelectorAll('.wp-block-cover.has-link').forEach(cover => {
        const link = cover.getAttribute('data-link')
        const container = cover.querySelector('.wp-block-cover__inner-container')

        if (link && container) {
            const a = document.createElement('a')
            a.href = link
            a.classList.add('wp-block-cover__inner-container')
            a.innerHTML = container.innerHTML

            container.parentNode.insertBefore(a, container)
            container.parentNode.removeChild(container)
        }
    })
}

const registerSidebarHandler = () => {
    document.body.addEventListener('click', () => {
        if (document.body.classList.contains('sidebar-open')) {
            document.body.classList.remove('sidebar-open')
        }
    })

    document.querySelectorAll('.menu-toggle').forEach(toggle => {
        toggle.addEventListener('click', e => {
            e.preventDefault()
            e.stopPropagation()
            document.body.classList.toggle('sidebar-open')
        })
    });

    document.querySelectorAll('.menu-close').forEach(toggle => {
        toggle.addEventListener('click', e => {
            e.preventDefault()
            e.stopPropagation()
            document.body.classList.toggle('sidebar-open')
        })
    });
}

const registerHeaderScrollBehaviour = () => {
    let scrollDirection = {
        direction: null,
        lastChange: 0,
        lastPosition: 0
    }

    const checkTop = () => {
        if (window.scrollY > 50) {
            document.body.classList.remove('top')
        } else {
            document.body.classList.add('top')
        }

        const lastPosition = scrollDirection.lastPosition
        scrollDirection.lastPosition = window.scrollY

        const currentDirection = window.scrollY > lastPosition ? 'down' : 'up'
        if (currentDirection !== scrollDirection.direction) {
            scrollDirection.direction = currentDirection
            scrollDirection.lastChange = window.scrollY
            return
        }

        let diff = window.scrollY - scrollDirection.lastChange
        if (diff < 0) {
            diff = 0 - diff
        }

        if (scrollDirection.direction === 'up' && diff > 40 && !document.body.classList.contains('force-header')) {
            document.body.classList.add('force-header')
            return
        }

        if (scrollDirection.direction === 'down' && document.body.classList.contains('force-header')) {
            document.body.classList.remove('force-header')
        }
    }

    checkTop()
    window.addEventListener('scroll', checkTop)
}

const registerAmountInputs = () => {
    const register = () => {
        document.querySelectorAll('.input-amount').forEach(container => {
            const input = container.querySelector('input')
            const setValue = value => {
                if (value === 0) {
                    value = 1
                }
                input.value = value
            }
            input.addEventListener('keyup', e => {
                input.value = input.value.split('').filter(ch => {
                    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(ch))
                }).join('')
            })
            input.addEventListener('blur', e => {
                if (!input.value) {
                    input.value = 1
                }
            })
            container.querySelectorAll('a').forEach(link => {
                link.addEventListener('click', () => {
                    const direction = link.classList[0].replace('btn-', '')
                    setValue(direction === 'up' ? parseInt(input.value) + 1 : parseInt(input.value) - 1)
                })
            })
        })
    }

    register()

    if (typeof registerLoadMoreProductsCallback !== 'undefined') {
        registerLoadMoreProductsCallback(register)
    }
}

const registerDownArrow = () => {
    document.querySelectorAll('.tinnauer-arrow-down').forEach(arrow => {
        arrow.addEventListener('click', () => {
            let next = arrow.nextSibling
            let i = 0
            while (next && next.nodeName === '#text') {
                next = next.nextSibling
                i++
                if (i === 3) {
                    break
                }
            }

            if (next) {
                const top = next.getBoundingClientRect().top
                next.scrollIntoView({
                    behavior: 'smooth'
                })
            }
        })
    })
}

const registerToplink = () => {
    const link = document.getElementById('top-link')
    if (typeof link !== 'undefined') {
        link.addEventListener('click', () => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        })
    }
}

window.addEventListener('load', () => {
    registerHeaderScrollBehaviour()
    registerResponsiveHeaderCheck()
    registerSidebarHandler()
    addCoverBlockLinks()
    registerAmountInputs()
    registerDownArrow()
    registerToplink()
})
